// Jewelry module — French strings (core pages)
export const frCore: Record<string, string> = {};
